// extracted by mini-css-extract-plugin
export default {"title":"applications-components-common-Gallery-gallery-module__title","description":"applications-components-common-Gallery-gallery-module__description"};
    if(module.hot) {
      // 1791528099860
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  